import { gql } from "apollo-boost";

export const GET_MEET = gql`
  query {
    allMeet(sort: MEET_ID_DESC) {
      edges {
        node {
          meetId
          meetName
          meetDesc
          contactInfo
          meetType
          meetDate
          meetDateTo
          sport
          urlToDetails
          state
          tag
          facilityId
          leagueSeqno
          updateDate
          userId
          updateSource
          id
        }
      }
    }
  }
`;
